import React from 'react';
import { Link } from 'react-router-dom';
import { LegalPageProps } from '../interfaces';
import { legalContent } from './legalContent';
import './legalPage.scss';

const LegalPage = ({ page }: LegalPageProps) => {
  const content = legalContent[page];
  const policyLinks = [
    { to: '/privacy', label: 'Privacy policy' },
    { to: '/terms', label: 'Terms of service' },
    { to: '/returns', label: 'Returns and refunds' },
    { to: '/shipping', label: 'Shipping and delivery' },
    { to: '/cookies', label: 'Cookie preferences' },
  ];

  return (
    <section className="legal-page" aria-label={content.title}>
      <header className="legal-page__header">
        <p>{content.eyebrow}</p>
        <h1>{content.title}</h1>
        <span>Last updated: June 22, 2026</span>
        <div>{content.intro}</div>
      </header>
      <div className="legal-page__body">
        {content.sections.map((section) => (
          <section key={section.title}>
            <h2>{section.title}</h2>
            {section.paragraphs?.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
            {section.bullets && <ul>{section.bullets.map((item) => <li key={item}>{item}</li>)}</ul>}
          </section>
        ))}
      </div>
      <section className="legal-page__related" aria-label="Related customer information">
        <div className="legal-page__related-header">
          <p>Related customer information</p>
          <Link className="legal-page__support-link" to="/support">Contact support</Link>
        </div>
        <nav className="legal-page__links" aria-label="Customer policy links">
          {policyLinks.map((link) => (
            <Link key={link.to} to={link.to} aria-current={link.to === `/${page}` ? 'page' : undefined}>
              {link.label}
            </Link>
          ))}
        </nav>
      </section>
    </section>
  );
};

export default LegalPage;
